import * as React from "react";

import cn from "classnames";

import { DropdownContext } from "./DropdownProvider";
import { DropdownMenuItemProps } from "./DropdownMenuItem";

export interface DropdownMenuLinkItemProps extends DropdownMenuItemProps {
    /**
     * Url to prepend to search result links
     */
     linkUrl?: string;
     prefixIcon?: React.ReactNode | ((index: number) => React.ReactNode)
     postLabelText?: React.ReactNode | ((index: number) => React.ReactNode);
     openInNewWindow?: boolean;
}

export const DropdownMenuLinkItem = (props: React.PropsWithChildren<DropdownMenuLinkItemProps>) => {
    const {
        item,
        index,
        linkUrl,
        prefixIcon,
        postLabelText,
        openInNewWindow = true
    } = props;

    const { classes, itemProps, highlightedIndex } = React.useContext(DropdownContext);

    const selected = highlightedIndex === index;
    const className = cn(
        classes?.listItem,
        selected ? classes?.listItemSelected : null
    );

    const fullUrl = `${linkUrl || ""}${item?.value}`;

    let prefixIconComponent = null;
    let postLabelTextComponent = null;

    if (prefixIcon && index !== undefined) {
        prefixIconComponent = typeof prefixIcon === "function" ? prefixIcon(index) : prefixIcon;
    }

    if (postLabelText && index !== undefined) {
        postLabelTextComponent = typeof postLabelText === "function" ? postLabelText(index) : postLabelText;
    }

    return typeof index === "number" && item ? (
        <li
            className={className}
            {...itemProps[index]}
            role="option"
            aria-selected={selected}
        >
            { prefixIconComponent }
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
                href={fullUrl}
                target={openInNewWindow ? "_blank" : "_self"}
            >
                <span className={classes?.listItemText}>{item.label}</span>
                {postLabelTextComponent}
            </a>
        </li>
    ) : null;
};
